import { Button, Flex, Group, Text } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form/lib/types'
import ButtonFilter from '@v2/commons/components/FilterButton/FilterButton.component'
import SelectFilter from '@v2/commons/components/FilterSelect/FilterSelect.component'
import FilterTextDebounce from '@v2/commons/components/FilterTextInput/FilterTextDebounce.component.tsx'

import { type IUsersFilter } from '../../user.types'
import styles from './users-filters.module.scss'

interface UsersTableFilterProps {
  usersFiltersForm: UseFormReturnType<IUsersFilter>
  isProgrammaticFormUpdateRef: React.MutableRefObject<boolean>
  totalRecords: number
  organizationRoles: string[]
  filtersOpen: boolean
  setFiltersOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const UsersTableFilter = ({
  usersFiltersForm,
  isProgrammaticFormUpdateRef,
  totalRecords,
  organizationRoles,
  filtersOpen,
  setFiltersOpen,
}: UsersTableFilterProps) => {
  const handleClearFilters = () => {
    usersFiltersForm.reset()
  }

  const handleChangeValue = (
    path: keyof IUsersFilter,
    value: IUsersFilter[keyof IUsersFilter],
  ) => {
    usersFiltersForm.setFieldValue(path, value)
    if (isProgrammaticFormUpdateRef.current) {
      isProgrammaticFormUpdateRef.current = false
    }
  }

  return (
    <>
      <Flex justify="space-between" align="center" mb="30px">
        <ButtonFilter
          onClick={() => setFiltersOpen((prev) => !prev)}
          isOpen={filtersOpen}
        />
        <Text lh="26px" size="18px">
          Total Records: {totalRecords}
        </Text>
      </Flex>
      {filtersOpen && (
        <form style={{ marginBottom: '30px' }}>
          <Group
            preventGrowOverflow={false}
            grow={true}
            classNames={{ root: styles['group-root'] }}
          >
            <SelectFilter
              options={organizationRoles}
              placeholder="Role"
              {...usersFiltersForm.getInputProps('organizationRole')}
              key={usersFiltersForm.key('organizationRole')}
              onChange={(value: IUsersFilter[keyof IUsersFilter]) => {
                handleChangeValue('organizationRole', value)
              }}
            />
            <FilterTextDebounce
              placeholder="Search"
              key={usersFiltersForm.key('search')}
              {...usersFiltersForm.getInputProps('search-users-filter')}
              debounceFunc={(value) => handleChangeValue('search', value)}
            />

            <Flex miw="50%" justify="flex-end">
              <Button
                variant="transparent"
                classNames={{ root: styles['clear-button-root'] }}
                onClick={handleClearFilters}
                type="button"
              >
                Clear All
              </Button>
            </Flex>
          </Group>
        </form>
      )}
    </>
  )
}

export default UsersTableFilter
